import type { VoidFunctionComponent } from 'react';
import { getCurrentPlanType } from '../utils';
import FullFeatureTable from './featuresTable';
import { window } from '../../../../globals';
import { usePlansContext } from './PlansContext';
import PlansHeader from './PlansHeader';
import PlanCards from './PlanCards';
import Loader from '../../../generic/Loader';

export type ViewIntervalOptions = 'month' | 'year';

const Plans: VoidFunctionComponent = () => {
  const {
    plans,
    isLoading,
  } = usePlansContext();

  if (isLoading) {
    return (<Loader />);
  }

  if (!plans) {
    return null;
  }

  const org = window?.user?.organization;
  if (!org) {
    return null;
  }
  const currentPlanType = getCurrentPlanType(org);

  return (
    <>
      <PlansHeader />
      <PlanCards />
      <FullFeatureTable currentPlanType={currentPlanType} />
    </>
  );
};

export default Plans;
